import { render } from "./GeneralJoinType.vue?vue&type=template&id=9a905efc&scoped=true&ts=true"
import script from "./GeneralJoinType.vue?vue&type=script&lang=ts"
export * from "./GeneralJoinType.vue?vue&type=script&lang=ts"

import "./GeneralJoinType.vue?vue&type=style&index=0&id=9a905efc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a905efc"]])

export default __exports__